export const environment = {
    production: false,
    apiUrl: 'https://dev.usinaco.work/api',
    userPanelUrl: '/app/auth/login'

};
